import { render, staticRenderFns } from "./HelpPageList.vue?vue&type=template&id=3a658976&scoped=true"
import script from "./HelpPageList.vue?vue&type=script&lang=js"
export * from "./HelpPageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a658976",
  null
  
)

export default component.exports